define(['morningstar'], function(morningstar) {
    'use strict';
    morningstar.asterix.ng.register('ecMultipleChart', require('../config/.generated/.defaults.json').ecMultipleChart);

    require('./multiple-chart.js');
    require('./transforms/from-pa-api-hypo-to-growth-table.js');
    require('./transforms/from-markets.js');
    require('./transforms/to-markets.js');
    require('./transforms/to-markets-price-and-distributions.js');
    require('./transforms/from-markets-price-and-distributions.js');
    require('./csv-service');
    require('./export-service');
});



// WEBPACK FOOTER //
// ./components/multiple-chart/src/js/_entrypoint.js